export default __webpack_public_path__ + "static/media/portfolio-wilo-3.5d133182.jpg";